import {number_format} from "../../../utils/formatter";
import dcopy from 'deep-copy';

const inflowData = {
  pv: 0,
  searchEngine: {
    label: "검색",
    total: 0,
    totalNumberFormat: 0,
    percentage: 0,
    list: [
      {
        name: "naver",
        label: "네이버 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "daum",
        label: "다음 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "google",
        label: "구글 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "zum",
        label: "줌 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "bing",
        label: "빙 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "yahoo",
        label: "야후 검색",
        count: 0,
        countNumberFormat: 0,
      },
      {
        name: "etc",
        label: "기타 검색",
        count: 0,
        countNumberFormat: 0,
      }
    ]
  },
  sns: {
    label: "SNS",
    total: 0,
    totalNumberFormat: 0,
    percentage: 0,
    list:
      [
        {
          name: "kakaotalk",
          label: "카카오톡",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "kakaostory",
          label: "카카오스토리",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "facebook",
          label: "페이스북",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "twitter",
          label: "트위터",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "youtube",
          label: "유튜브",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "instagram",
          label: "인스타그램",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "etc",
          label: "기타 SNS",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        }
      ]
  },
  ref: {
    label: "기타",
    total: 0,
    totalNumberFormat: 0,
    percentage: 0,
    list:
      [
        {
          name: "refEtc",
          label: "직접 유입",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "ref",
          label: "기타 유입",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        }
      ]
  },
  deviceType: {
    label: "디바이스",
    total: 0,
    totalNumberFormat: 0,
    percentage: 0,
    list:
      [
        {
          name: "mobile",
          label: "모바일",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        },
        {
          name: "pc",
          label: "PC",
          count: 0,
          countNumberFormat: 0,
          percentage: 0,
        }
      ]
  },
};

export const copyInflowData = () => {
  return dcopy(inflowData);
};

export const assignDataByDefault = (data, isEarlierThanCreationDate) => {
  let newInflowData = copyInflowData();

  if (data) {
    newInflowData.pv = data.pv;
    newInflowData.searchEngine = parseItem(newInflowData, newInflowData.pv, "searchEngine", data.searchEngine, isEarlierThanCreationDate);
    newInflowData.sns = parseItem(newInflowData, newInflowData.pv, "sns", data.sns, isEarlierThanCreationDate);
    newInflowData.ref = parseItem(newInflowData, newInflowData.pv, "ref", data.ref, isEarlierThanCreationDate);
    newInflowData.deviceType = parseItem(newInflowData, newInflowData.pv, "deviceType", data.deviceType, isEarlierThanCreationDate);
  }

  return newInflowData;
};


export const hasRef = (list) => {

  if (list === null) return false;

  const refEtc = list.find(item => item.name === "ref");

  return (refEtc !== null && refEtc.count > 0)
};


const calculateCount = (count, isEarlierThanCreationDate) => {
  return isEarlierThanCreationDate
    ? "-"
    : number_format(count);
};


const getPercentage = (count, total) => {
  const percentage = (count / total) * 100;
  return percentage > 0 ? Math.round(percentage) : 0;
};


const parseItem = (newInflowData, totalPv, key, fromItem, isEarlierThanCreationDate) => {
  let newInflow = newInflowData[key];
  const {total, list} = fromItem;

  newInflow.total = total || 0;
  newInflow.totalNumberFormat = calculateCount(newInflow.total, isEarlierThanCreationDate);
  newInflow.percentage = getPercentage(newInflow.total, totalPv);

  newInflow.list = newInflow.list.map((item) => {

    if (list && list.hasOwnProperty(item.name)) {
      item.count = list[item.name];
      item.percentage = getPercentage(item.count, newInflow.total);
    }

    item.countNumberFormat = calculateCount(item.count, isEarlierThanCreationDate);

    return item;
  });

  return newInflow;
};
